// import React, { useEffect, useState, useRef } from "react";
// import { AuthAPI } from "../api/AuthAPI";
// import DashboardLayout from "../layouts/DashboardLayout";

// export default function ProfilePage() {
//   const [name, setName] = useState("");
//   const [phone, setPhone] = useState("");
//   const [email, setEmail] = useState("");
//   const [emailVerified, setEmailVerified] = useState(false);

//   const [photoUrl, setPhotoUrl] = useState(null);
//   const photoFileRef = useRef(null);

//   const [oldPassword, setOldPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");

//   const [activeTab, setActiveTab] = useState("profile");
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [savingProfile, setSavingProfile] = useState(false);
//   const [changingPwd, setChangingPwd] = useState(false);

//   const [profileMsg, setProfileMsg] = useState({
//     type: "",
//     text: "",
//   });

//   const [pwdMsg, setPwdMsg] = useState({
//     type: "",
//     text: "",
//   });

//   const [phoneError, setPhoneError] = useState("");

//   const isValidPhone = (value) =>
//     /^[0-9]{10}$/.test(value);

//   useEffect(() => {
//     let mounted = true;
//     let currentBlob = null;

//     async function loadProfile() {
//       try {
//         const res = await AuthAPI.getMyDetails();
//         const data =
//           res?.data?.data ?? res?.data ?? res;

//         if (!mounted) return;

//         setName(data?.name || "");
//         setPhone(data?.phone || "");
//         setEmail(data?.email || "");
//         setEmailVerified(
//           Boolean(data?.emailVerified)
//         );
//         setPhotoUrl(data?.image || null);
//       } catch (err) {
//         setProfileMsg({
//           type: "error",
//           text:
//             err?.response?.data?.message ||
//             "Failed to load profile",
//         });
//       } finally {
//         if (mounted) setLoadingProfile(false);
//       }
//     }

//     loadProfile();

//     return () => {
//       mounted = false;
//       if (
//         currentBlob &&
//         currentBlob.startsWith("blob:")
//       ) {
//         URL.revokeObjectURL(currentBlob);
//       }
//     };
//   }, []);

//   useEffect(() => {
//     setProfileMsg({ type: "", text: "" });
//     setPwdMsg({ type: "", text: "" });
//   }, [activeTab]);

//   function handlePhotoChange(e) {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     if (
//       photoUrl &&
//       photoUrl.startsWith("blob:")
//     ) {
//       URL.revokeObjectURL(photoUrl);
//     }

//     photoFileRef.current = file;
//     setPhotoUrl(URL.createObjectURL(file));
//   }

//   function handleRemovePhoto() {
//     if (
//       photoUrl &&
//       photoUrl.startsWith("blob:")
//     ) {
//       URL.revokeObjectURL(photoUrl);
//     }

//     photoFileRef.current = null;
//     setPhotoUrl(null);
//   }

//   async function handleUpdateProfile(e) {
//     e.preventDefault();

//     setProfileMsg({
//       type: "",
//       text: "",
//     });

//     if (!isValidPhone(phone)) {
//       setPhoneError(
//         "Phone number must be exactly 10 digits"
//       );
//       return;
//     }

//     setSavingProfile(true);

//     try {
//       const formData = new FormData();

//       formData.append("name", name);
//       formData.append("email", email);
//       formData.append("phone", phone);

//       if (photoFileRef.current) {
//         formData.append(
//           "image",
//           photoFileRef.current
//         );
//       }

//       const res =
//         await AuthAPI.updateCandidateDetails(
//           formData
//         );

//       setProfileMsg({
//         type: "success",
//         text:
//           res?.data?.message ||
//           "Profile updated successfully",
//       });
//     } catch (err) {
//       setProfileMsg({
//         type: "error",
//         text:
//           err?.response?.data?.message ||
//           "Profile update failed",
//       });
//     } finally {
//       setSavingProfile(false);
//     }
//   }

//   async function handleChangePassword(e) {
//     e.preventDefault();

//     setPwdMsg({
//       type: "",
//       text: "",
//     });

//     if (
//       !oldPassword ||
//       !newPassword ||
//       !confirmNewPassword
//     ) {
//       setPwdMsg({
//         type: "error",
//         text: "All fields are required",
//       });
//       return;
//     }

//     if (newPassword.length < 6) {
//       setPwdMsg({
//         type: "error",
//         text:
//           "Password must be at least 6 characters",
//       });
//       return;
//     }

//     if (
//       newPassword !== confirmNewPassword
//     ) {
//       setPwdMsg({
//         type: "error",
//         text: "Passwords do not match",
//       });
//       return;
//     }

//     setChangingPwd(true);

//     try {
//       const payload = {
//         old_password: oldPassword,
//         new_password: newPassword,
//         confirm_password:
//           confirmNewPassword,
//       };

//       const res =
//         await AuthAPI.changePassword(
//           payload
//         );

//       setPwdMsg({
//         type: "success",
//         text:
//           res?.data?.message ||
//           "Password updated",
//       });

//       setOldPassword("");
//       setNewPassword("");
//       setConfirmNewPassword("");
//     } catch (err) {
//       setPwdMsg({
//         type: "error",
//         text:
//           err?.response?.data?.message ||
//           "Password update failed",
//       });
//     } finally {
//       setChangingPwd(false);
//     }
//   }

//   if (loadingProfile) {
//     return (
//       <DashboardLayout>
//         <div className="p-8 text-gray-500">
//           Loading profile...
//         </div>
//       </DashboardLayout>
//     );
//   }

//   return (
//     <DashboardLayout>
//       <div className="space-y-6">
//         <h2 className="text-lg font-semibold mt-4">
//           Profile Settings
//         </h2>

//         <p className="text-sm text-gray-600">
//           Manage your account settings
//         </p>

//         <div className="flex gap-3">
//           <button
//             onClick={() =>
//               setActiveTab("profile")
//             }
//             className={`px-4 py-2 rounded-full text-sm ${
//               activeTab === "profile"
//                 ? "bg-blue-300"
//                 : "hover:bg-blue-100 text-gray-600"
//             }`}
//           >
//             Profile
//           </button>

//           <button
//             onClick={() =>
//               setActiveTab("security")
//             }
//             className={`px-4 py-2 rounded-full text-sm ${
//               activeTab === "security"
//                 ? "bg-blue-300"
//                 : "hover:bg-blue-100 text-gray-600"
//             }`}
//           >
//             Security
//           </button>
//         </div>

//         {activeTab === "profile" && (
//           <form
//             onSubmit={
//               handleUpdateProfile
//             }
//             className="bg-white border rounded p-6 space-y-4 max-w-xl"
//           >
//             {profileMsg.text && (
//               <div
//                 className={`p-3 rounded text-sm ${
//                   profileMsg.type ===
//                   "success"
//                     ? "bg-green-100 text-green-700"
//                     : "bg-red-100 text-red-700"
//                 }`}
//               >
//                 {profileMsg.text}
//               </div>
//             )}

//             <input
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-orange-300"
//               value={name}
//               onChange={(e) =>
//                 setName(
//                   e.target.value
//                 )
//               }
//               placeholder="Your name"
//             />

//             <input
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-orange-300"
//               value={phone}
//               onChange={(e) => {
//                 const v =
//                   e.target.value;

//                 if (
//                   !/^\d*$/.test(v)
//                 )
//                   return;

//                 if (
//                   v.length > 10
//                 )
//                   return;

//                 setPhone(v);
//                 setPhoneError("");
//               }}
//               placeholder="Phone"
//             />

//             {phoneError && (
//               <p className="text-xs text-red-600">
//                 {phoneError}
//               </p>
//             )}

//             <input
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-orange-300"
//               value={email}
//               onChange={(e) =>
//                 setEmail(
//                   e.target.value
//                 )
//               }
//               placeholder="Email"
//             />

//             {emailVerified && (
//               <p className="text-green-600 text-sm">
//                 Email verified
//               </p>
//             )}

//             <input
//               type="file"
//               accept="image/*"
//               onChange={
//                 handlePhotoChange
//               }
//             />

//             {photoUrl && (
//               <div className="space-y-2">
//                 <img
//                   src={photoUrl}
//                   alt="profile"
//                   className="w-20 h-20 rounded object-cover"
//                 />

//                 <button
//                   type="button"
//                   onClick={
//                     handleRemovePhoto
//                   }
//                   className="text-red-600 text-sm"
//                 >
//                   Remove photo
//                 </button>
//               </div>
//             )}

//             <button
//               type="submit"
//               disabled={
//                 savingProfile
//               }
//               className="bg-orange-400 text-white px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {savingProfile
//                 ? "Saving..."
//                 : "Update Profile"}
//             </button>
//           </form>
//         )}

//         {activeTab === "security" && (
//           <form
//             onSubmit={
//               handleChangePassword
//             }
//             className="bg-white border rounded p-6 space-y-4 max-w-xl"
//           >
//             {pwdMsg.text && (
//               <div
//                 className={`p-3 rounded text-sm ${
//                   pwdMsg.type ===
//                   "success"
//                     ? "bg-green-100 text-green-700"
//                     : "bg-red-100 text-red-700"
//                 }`}
//               >
//                 {pwdMsg.text}
//               </div>
//             )}

//             <input
//               type="password"
//               placeholder="Current password"
//               className="w-full border px-3 py-2 rounded"
//               value={oldPassword}
//               onChange={(e) =>
//                 setOldPassword(
//                   e.target.value
//                 )
//               }
//             />

//             <input
//               type="password"
//               placeholder="New password"
//               className="w-full border px-3 py-2 rounded"
//               value={newPassword}
//               onChange={(e) =>
//                 setNewPassword(
//                   e.target.value
//                 )
//               }
//             />

//             <input
//               type="password"
//               placeholder="Confirm new password"
//               className="w-full border px-3 py-2 rounded"
//               value={
//                 confirmNewPassword
//               }
//               onChange={(e) =>
//                 setConfirmNewPassword(
//                   e.target.value
//                 )
//               }
//             />

//             <button
//               disabled={
//                 changingPwd
//               }
//               className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {changingPwd
//                 ? "Updating..."
//                 : "Change Password"}
//             </button>
//           </form>
//         )}
//       </div>
//     </DashboardLayout>
//   );
// }















import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { AuthAPI } from "../api/AuthAPI";
import DashboardLayout from "../layouts/DashboardLayout";

export default function ProfilePage() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);

  const [photoUrl, setPhotoUrl] = useState(null);
  const photoFileRef = useRef(null);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const [activeTab, setActiveTab] = useState("profile");
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [savingProfile, setSavingProfile] = useState(false);
  const [changingPwd, setChangingPwd] = useState(false);

  const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });
  const [pwdMsg, setPwdMsg] = useState({ type: "", text: "" });
  const [phoneError, setPhoneError] = useState("");

  const isValidPhone = (value) => /^[0-9]{10}$/.test(value);

  useEffect(() => {
    let mounted = true;
    let currentBlob = null;

    async function loadProfile() {
      try {
        const res = await AuthAPI.getMyDetails();
        const data = res?.data?.data ?? res?.data ?? res;

        if (!mounted) return;

        setName(data?.name || "");
        setPhone(data?.phone || "");
        setEmail(data?.email || "");
        setEmailVerified(Boolean(data?.emailVerified));
        setPhotoUrl(data?.image || null);
      } catch (err) {
        setProfileMsg({
          type: "error",
          text: err?.response?.data?.message || "Failed to load profile",
        });
      } finally {
        if (mounted) setLoadingProfile(false);
      }
    }

    loadProfile();

    return () => {
      mounted = false;
      if (currentBlob && currentBlob.startsWith("blob:")) {
        URL.revokeObjectURL(currentBlob);
      }
    };
  }, []);

  useEffect(() => {
    setProfileMsg({ type: "", text: "" });
    setPwdMsg({ type: "", text: "" });
  }, [activeTab]);

  function handlePhotoChange(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    if (photoUrl && photoUrl.startsWith("blob:")) {
      URL.revokeObjectURL(photoUrl);
    }

    photoFileRef.current = file;
    setPhotoUrl(URL.createObjectURL(file));
  }

  function handleRemovePhoto() {
    if (photoUrl && photoUrl.startsWith("blob:")) {
      URL.revokeObjectURL(photoUrl);
    }

    photoFileRef.current = null;
    setPhotoUrl(null);
  }

  async function handleUpdateProfile(e) {
    e.preventDefault();
    setProfileMsg({ type: "", text: "" });

    if (!isValidPhone(phone)) {
      setPhoneError("Phone number must be exactly 10 digits");
      return;
    }

    setSavingProfile(true);

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("phone", phone);

      if (photoFileRef.current) {
        formData.append("image", photoFileRef.current);
      }

      const res = await AuthAPI.updateCandidateDetails(formData);

      setProfileMsg({
        type: "success",
        text: res?.data?.message || "Profile updated successfully",
      });
    } catch (err) {
      setProfileMsg({
        type: "error",
        text: err?.response?.data?.message || "Profile update failed",
      });
    } finally {
      setSavingProfile(false);
    }
  }

  async function handleChangePassword(e) {
    e.preventDefault();
    setPwdMsg({ type: "", text: "" });

    if (!oldPassword || !newPassword || !confirmNewPassword) {
      setPwdMsg({ type: "error", text: "All fields are required" });
      return;
    }

    if (newPassword.length < 6) {
      setPwdMsg({
        type: "error",
        text: "Password must be at least 6 characters",
      });
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setPwdMsg({ type: "error", text: "Passwords do not match" });
      return;
    }

    setChangingPwd(true);

    try {
      const payload = {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmNewPassword,
      };

      const res = await AuthAPI.changePassword(payload);

      setPwdMsg({
        type: "success",
        text: res?.data?.message || "Password updated",
      });

      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (err) {
      setPwdMsg({
        type: "error",
        text: err?.response?.data?.message || "Password update failed",
      });
    } finally {
      setChangingPwd(false);
    }
  }

  if (loadingProfile) {
    return (
      <DashboardLayout>
        <div className="p-8 text-gray-500">Loading profile...</div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="mt-12 md:mt-0 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-xl"
        >
          <div className="rounded-2xl bg-white border border-gray-200 shadow-sm">
            {/* PROFILE HEADER */}
            <div className="flex items-center gap-4 p-6 border-b border-gray-100">
              <div className="w-16 h-16 rounded-full overflow-hidden border border-gray-200 shrink-0">
                <img
                  src={photoUrl || "/avatar.png"}
                  alt="profile"
                  className="w-full h-full object-cover bg-gray-50"
                />
              </div>

              <div className="min-w-0">
                <h2 className="font-semibold text-lg text-gray-900 truncate">
                  {name}
                </h2>
                <p className="text-sm text-gray-500 truncate">{email}</p>
                <p className="text-xs text-gray-400">{phone}</p>
                {emailVerified && (
                  <span className="inline-flex items-center gap-1 text-green-600 text-xs mt-1 font-medium">
                    ✓ Email verified
                  </span>
                )}
              </div>
            </div>

            {/* TABS */}
            {/* <div className="flex border-b border-gray-100 px-2">
              <button
                type="button"
                onClick={() => setActiveTab("profile")}
                className={`px-4 py-3 text-sm font-medium border-b-2 -mb-px transition ${
                  activeTab === "profile"
                    ? "border-gray-900 text-gray-900"
                    : "border-transparent text-gray-400 hover:text-gray-600"
                }`}
              >
                Profile
              </button>

              <button
                type="button"
                onClick={() => setActiveTab("security")}
                className={`px-4 py-3 text-sm font-medium border-b-2 -mb-px transition ${
                  activeTab === "security"
                    ? "border-gray-900 text-gray-900"
                    : "border-transparent text-gray-400 hover:text-gray-600"
                }`}
              >
                Security
              </button>
            </div> */}

            {/* PROFILE TAB */}
            {activeTab === "profile" && (
              <form onSubmit={handleUpdateProfile} className="space-y-5 p-6">
                {profileMsg.text && (
                  <div
                    className={`p-3 rounded-lg text-sm border ${
                      profileMsg.type === "success"
                        ? "bg-green-50 text-green-700 border-green-200"
                        : "bg-red-50 text-red-700 border-red-200"
                    }`}
                  >
                    {profileMsg.text}
                  </div>
                )}

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    className="w-full border border-gray-200 px-3 py-2.5 rounded-lg mt-1.5 outline-none focus:border-gray-900 transition"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Phone
                  </label>
                  <input
                    className={`w-full border px-3 py-2.5 rounded-lg mt-1.5 outline-none transition ${
                      phoneError
                        ? "border-red-400 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-900"
                    }`}
                    value={phone}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (!/^\d*$/.test(v)) return;
                      if (v.length > 10) return;
                      setPhone(v);
                      setPhoneError("");
                    }}
                    placeholder="Phone"
                  />
                  {phoneError && (
                    <p className="text-xs text-red-600 mt-1">{phoneError}</p>
                  )}
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    className="w-full border border-gray-200 px-3 py-2.5 rounded-lg mt-1.5 outline-none focus:border-gray-900 transition"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Profile Image
                  </label>

                  <div className="flex items-center gap-4 mt-2">
                    {photoUrl && (
                      <img
                        src={photoUrl}
                        alt="profile"
                        className="w-14 h-14 rounded-full object-cover border border-gray-200"
                      />
                    )}

                    <div className="flex flex-col gap-1.5">
                      <input
                        id="profileUpload"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handlePhotoChange}
                      />

                      <label
                        htmlFor="profileUpload"
                        className="inline-flex items-center justify-center cursor-pointer
                                   rounded-lg px-4 py-2 text-sm font-medium
                                   border border-gray-300 text-gray-700
                                   hover:bg-gray-50 transition w-fit"
                      >
                        Upload photo
                      </label>

                      {photoUrl && (
                        <button
                          type="button"
                          onClick={handleRemovePhoto}
                          className="text-red-600 text-xs font-medium text-left hover:underline w-fit"
                        >
                          Remove photo
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={savingProfile}
                  className="w-full bg-blue-900 hover:bg-blue-800 text-white py-2.5 rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {savingProfile ? "Saving..." : "Save Changes"}
                </button>
              </form>
            )}

            {/* SECURITY TAB */}
            {activeTab === "security" && (
              <form onSubmit={handleChangePassword} className="space-y-4 p-6">
                {pwdMsg.text && (
                  <div
                    className={`p-3 rounded-lg text-sm border ${
                      pwdMsg.type === "success"
                        ? "bg-green-50 text-green-700 border-green-200"
                        : "bg-red-50 text-red-700 border-red-200"
                    }`}
                  >
                    {pwdMsg.text}
                  </div>
                )}

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Current password
                  </label>
                  <input
                    type="password"
                    placeholder="Enter current password"
                    className="w-full border border-gray-200 px-3 py-2.5 rounded-lg mt-1.5 outline-none focus:border-gray-900 transition"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    New password
                  </label>
                  <input
                    type="password"
                    placeholder="Enter new password"
                    className="w-full border border-gray-200 px-3 py-2.5 rounded-lg mt-1.5 outline-none focus:border-gray-900 transition"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-700">
                    Confirm new password
                  </label>
                  <input
                    type="password"
                    placeholder="Confirm new password"
                    className="w-full border border-gray-200 px-3 py-2.5 rounded-lg mt-1.5 outline-none focus:border-gray-900 transition"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                  />
                </div>

                <button
                  type="submit"
                  disabled={changingPwd}
                  className="w-full bg-gray-900 hover:bg-gray-800 text-white py-2.5 rounded-lg font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {changingPwd ? "Updating..." : "Change Password"}
                </button>
              </form>
            )}
          </div>
        </motion.div>
      </div>
    </DashboardLayout>
  );
}